var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.18306 21.8169C6.93898 21.5729 6.93898 21.1771 7.18306 20.9331L16.1161 12L7.18306 3.06694C6.93898 2.82286 6.93898 2.42713 7.18306 2.18306C7.42714 1.93898 7.82287 1.93898 8.06694 2.18306L17 11.1161C17 11.1161 17 11.1161 17.0001 11.1162C17.1162 11.2322 17.2083 11.3699 17.2712 11.5216C17.3341 11.6732 17.3665 11.8358 17.3665 12C17.3665 12.1642 17.3341 12.3268 17.2712 12.4784C17.2083 12.6301 17.1162 12.7678 17.0001 12.8838C17 12.8839 17 12.8839 17 12.8839L8.06694 21.8169C7.82287 22.061 7.42714 22.061 7.18306 21.8169Z",
  fill: "#06262D"
})));
export { SvgChevronRight as ReactComponent };
export default __webpack_public_path__ + "images/chevron-right.svg";